import { createContext } from 'react';
export const LayerContext = createContext(null);
//# sourceMappingURL=layerContext.js.map